const icons = ['next-arrow', 'popup-close', 'link-phone', 'link-mail'] as const;

export default icons;
